import { ReactNode } from "react";
import { SidebarProvider, SidebarTrigger, SidebarInset } from "@/components/ui/sidebar";
import Header from "@/components/layout/Header";
import DashboardSidebar from "./DashboardSidebar";
import { useTranslation } from "react-i18next";

interface DashboardLayoutProps {
  children: ReactNode;
  activeTab: string;
  onTabChange: (tab: string) => void;
  companyName?: string;
  title?: string;
  subtitle?: string;
}

const DashboardLayout = ({
  children,
  activeTab,
  onTabChange,
  companyName,
  title,
  subtitle,
}: DashboardLayoutProps) => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-subtle">
      <Header showLogoutButton={true} />
      
      <SidebarProvider defaultOpen={true}>
        <div className="flex min-h-screen w-full pt-16">
          <DashboardSidebar
            activeTab={activeTab}
            onTabChange={onTabChange}
            companyName={companyName}
          />
          
          <SidebarInset className="flex-1">
            <div className="flex items-center gap-4 border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 px-6 py-4 sticky top-16 z-30">
              <SidebarTrigger className="-ml-2" />
              <div className="flex-1">
                <h1 className="text-xl font-semibold text-foreground">
                  {title || t("dashboard.title", "HR Dashboard")}
                </h1>
                {subtitle && (
                  <p className="text-sm text-muted-foreground">{subtitle}</p>
                )}
              </div>
            </div>
            
            <main className="p-6">
              {children}
            </main>
          </SidebarInset>
        </div>
      </SidebarProvider>
    </div>
  );
};

export default DashboardLayout;
